export { default as homaLogo } from "../../../images/logo-homa-bjj.svg";

export type ScheduleEntry = { day: string; hours: string };

export const SCHEDULE: ScheduleEntry[] = [
  { day: "Lundi", hours: "19h30 - 21h00" },
  { day: "Mercredi", hours: "19h30 - 21h00" },
  { day: "Vendredi", hours: "19h30 - 21h00" },
  { day: "Dimanche", hours: "14h00 - 15h30" },
];

export const PHONE = "514-668-0275";
export const EMAIL = "sseguin007@live.ca";
export const ADDRESS = "1077 Chemin de Chambly, Longueuil, Qc, Ca";
